<template>
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52" height="52" rx="12" fill="white" />
    <path
      d="M23.1806 35.04L19.7569 31.64C19.4347 31.32 19.2736 30.9333 19.2736 30.48C19.2736 30.0267 19.4347 29.64 19.7569 29.32C20.0792 29 20.4685 28.84 20.925 28.84C21.3815 28.84 21.7708 29 22.0931 29.32L24.3083 31.52L29.9069 25.96C30.2292 25.64 30.6185 25.48 31.075 25.48C31.5315 25.48 31.9208 25.64 32.2431 25.96C32.5653 26.28 32.7264 26.6667 32.7264 27.12C32.7264 27.5733 32.5653 27.96 32.2431 28.28L25.4361 35.04C25.1407 35.3333 24.7648 35.48 24.3083 35.48C23.8519 35.48 23.4759 35.3333 23.1806 35.04ZM14.7222 42C13.8361 42 13.0773 41.6869 12.4457 41.0608C11.8152 40.4336 11.5 39.68 11.5 38.8V16.4C11.5 15.52 11.8152 14.7669 12.4457 14.1408C13.0773 13.5136 13.8361 13.2 14.7222 13.2H16.3333V11.6C16.3333 11.1467 16.4875 10.7664 16.7957 10.4592C17.1051 10.1531 17.488 10 17.9444 10C18.4009 10 18.7838 10.1531 19.0932 10.4592C19.4014 10.7664 19.5556 11.1467 19.5556 11.6V13.2H32.4444V11.6C32.4444 11.1467 32.5991 10.7664 32.9084 10.4592C33.2167 10.1531 33.5991 10 34.0556 10C34.512 10 34.8944 10.1531 35.2027 10.4592C35.512 10.7664 35.6667 11.1467 35.6667 11.6V13.2H37.2778C38.1639 13.2 38.9227 13.5136 39.5543 14.1408C40.1848 14.7669 40.5 15.52 40.5 16.4V38.8C40.5 39.68 40.1848 40.4336 39.5543 41.0608C38.9227 41.6869 38.1639 42 37.2778 42H14.7222ZM14.7222 38.8H37.2778V22.8H14.7222V38.8Z"
      fill="url(#paint0_linear_37_1636)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_37_1636"
        x1="11.5"
        y1="10"
        x2="43.4325"
        y2="38.7419"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
